import { reducer as postReducer, types as postsTypes } from "./posts";
import { reducer as commentsReducer, types as commentsTypes } from "./comments";
import { GlobalReducer } from "./types";

export const reducer: GlobalReducer = ({ comments, posts }, action) => ({
  comments: commentsReducer(comments, action as commentsTypes.IAction),
  posts: postReducer(posts, action as postsTypes.IAction)
});
